// extracted by mini-css-extract-plugin
export default {"GateBody":"map_GateBody__LJ164","SettingsContainer":"map_SettingsContainer__iybwT"};